module.exports = __webpack_public_path__ + "sg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sg.svg
// module id = 797
// module chunks = 0